import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const PRIVATE = /^\/(app|admin|studio|attiva)(\/|$)/;

export const VisitTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (PRIVATE.test(pathname)) return;
    api.post("/stats/hit", { path: pathname, ref: document.referrer || "" }).catch(() => {});
  }, [pathname]);
  return null;
};
